@for (item of contactPhones.controls; track item; let i = $index) {
  <div [formGroup]="item">
    <div class="row">
      <div class="phone-container">
        <pr-input-tel
          label="Votre numéro de téléphone mobile"
          [derrors]="derrors"
          placeholder="Exemple : Dupont"
          formControlName="phone"
          [isDefault]="false"
          type="text"
        >
        </pr-input-tel>
        @if (showWarningMobilePhone(item.get('phone').value)) {
          <div class="alert alert-danger">
            <p>
              Le numéro de téléphone mobile doit être un numéro de téléphone
              mobile français valide.
            </p>
          </div>
        }
      </div>
      @if (contactPhones.length > 1) {
        @if (contactPhones?.controls[i]?.get('phone')?.value) {
          <pr-button-confirm
            class="confirm"
            display="danger"
            clazz="pr-toolbar-button last"
            icon="delete_outline"
            title="Suppression"
            comment="Toute suppression est définitve, les données seront perdues."
            labelConfirm="Supprimer"
            labelCancel="Annuler"
            (onConfirm)="deleteFields(i)"
          >
            Êtes-vous sûr(e) de vouloir supprimer
            <em
              >“{{
                contactPhones?.controls[i]?.get('phone')?.value?.number
              }}”</em
            >
          </pr-button-confirm>
        } @else {
          <pr-button
            class="confirm"
            display="danger"
            clazz="pr-toolbar-button last"
            icon="delete_outline"
            (onClick)="deleteFields(i)"
          ></pr-button>
        }
      }
    </div>
  </div>
}

<pr-button-add
  type="button"
  display="neutral"
  (click)="addFields()"
  label="Ajouter un numéro de téléphone"
  rightIcon="+"
>
</pr-button-add>
